import React from 'react';
import PropTypes from 'prop-types';
import { AlertContainer, AlertIconWrapper, AlertContent, AlertTitle, AlertMessage } from './components/AlertInfoStyles';
import { getAlertIcon } from './utils/alertInfoHelpers';
import Icon from '../../atoms/Icon';

const AlertInfo = ({ type, title, message, children }) => {
  return (
    <AlertContainer type={type}>
      <AlertIconWrapper type={type}>
        <Icon className={`fas fa-${getAlertIcon(type)}`} size="md" color="inherit" />
      </AlertIconWrapper>
      <AlertContent>
        {title && <AlertTitle>{title}</AlertTitle>}
        {message && <AlertMessage>{message}</AlertMessage>}
        {children && <AlertMessage>{children}</AlertMessage>}
      </AlertContent>
    </AlertContainer>
  );
};

AlertInfo.propTypes = {
  type: PropTypes.oneOf(['info', 'success', 'warning', 'error', 'danger']),
  title: PropTypes.string,
  message: PropTypes.string,
  children: PropTypes.node,
};

AlertInfo.defaultProps = {
  type: 'info',
  title: undefined,
  message: undefined,
  children: null,
};

export default AlertInfo;



// WEBPACK FOOTER //
// ./src/design-system/molecules/AlertInfo/AlertInfo.jsx